import React from "react";
import { Link } from 'react-router-dom';
import './main.css';
import logotextlight from './assets/logo-text-light.png'

export function NavBar(props:React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>) {
    return (
        <div className="bg-black text-beige sticky top-0 w-full h-0 sm:h-20 z-50 flex flex-row items-center text-3xl font-unifraktur overflow-hidden">
                <div className="h-full text-4xl text-center pl-10 grow m-1">
                    <CustomLink href="/" className="h-full" underline={false}>
                        <img src={logotextlight} className="h-full " alt="background"/>
                    </CustomLink>
                </div>
                <div className="px-6">
                    <Button href="/about"> about </Button>
                </div>
                <div className="px-6">
                    <CustomLink href="/shop"> shop </CustomLink>
                </div>
                <div className="px-6">
                    <CustomLink href="/account"> account </CustomLink>
                </div>
        </div>
    );
}

type CustomLinkProps = {
    underline? : boolean
} & React.PropsWithChildren<React.HTMLProps<HTMLAnchorElement>>
export function CustomLink(props:CustomLinkProps){
    return (
        <Link to={props.href!} className={"group inline-block"+props.className} onClick={props.onClick!} viewTransition target={props.target}> 
            {props.children} 
            {props.underline ? <span className="block w-0 group-hover:w-full transition-all h-0.5 bg-white"/> : null}
            
        </Link>
    )
}

export function Button(props:React.PropsWithChildren<React.HTMLProps<HTMLAnchorElement>>) {
    return (
        <a className="bg-orange text-black px-2 py-1 rounded-tl-xl rounded-br-xl hover:cursor-pointer" href={props.href}>
            {props.children}
        </a>
    )
}

//TODO Footer element
export function Footer(props:React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>) {
    return (
        <div className="bg-black text-beige w-full h-0 lg:h-20 z-50 flex flex-row items-center text-3xl font-unifraktur">
                <div className="h-full text-4xl text-center pl-10 grow m-1">
                    <CustomLink href="/" className="h-full" underline={false}>
                        <img src={logotextlight} className="h-full " alt="logo"/>
                    </CustomLink>
                </div>
                <div className="px-6">
                    <Button href="/about"> about </Button>
                </div>
                <div className="px-6">
                    <CustomLink href="/shop"> shop </CustomLink>
                </div>
                <div className="px-6">
                    <CustomLink href="/account"> account </CustomLink>
                </div>
        </div>
    );
}